import {Navigate, Outlet, useLocation} from 'react-router';

import {useAuth} from 'context/AuthContext';


export default function ProtectedRoute() {
  const location = useLocation();
  const {isAuthenticated} = useAuth();

  if (isAuthenticated) {
    return <Outlet />;
  } else {
    return <Navigate to="/" replace={true} state={{from: location}} />;
  }
}
